export default "__VITE_ASSET__e$G5gBiiU8eppUgrm1MQ4A__"